'use strict';
// Regra extraída de globalUtils (Nova Matrícula), sem alterar prazos ou calendário.
module.exports = function criarCalendarioRecebimento(Holidays) {
// ====== MÓDULO DE DIAS ÚTEIS / FERIADOS ======
const _hd = new Holidays('BR', 'DF');   // default DF; pode trocar em runtime via setHolidaysUF

function _norm(s = '') {
  return String(s)
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .trim().toLowerCase();
}

// cria Date “local” no começo do dia sem derrapar fuso
function _mkDateLocal(iso /* 'YYYY-MM-DD' */) {
  const [y, m, d] = String(iso).split('-').map(Number);
  return new Date(y, (m - 1), d, 0, 0, 0, 0);
}
function _toISODateLocal(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
}
function _isWeekend(d) {
  const w = d.getDay();
  return w === 0 || w === 6;
}
function _isHoliday(d) {
  // A entrada é uma data civil de Brasília, não um instante no fuso do servidor.
  return Boolean(_hd.isHoliday(new Date(`${_toISODateLocal(d)}T00:00:00-03:00`), 'public'));
}
function _isBusinessDay(d) {
  return !_isWeekend(d) && !_isHoliday(d);
}
function _nextBusinessDay(d0) {
  const d = _mkDateLocal(_toISODateLocal(d0)); // clona “no local”
  while (!_isBusinessDay(d)) d.setDate(d.getDate() + 1);
  return d;
}

return {
 setHolidaysUF(uf = 'DF') { _hd.init('BR', uf); },
 nextBusinessDay(d) { return _nextBusinessDay(d instanceof Date ? d : _mkDateLocal(String(d))); },
  calcularDataRecebimento(dataPagIso, formaIdOrNameOrObj, formasLista = [], numeroParcela = 1) {
    if (!dataPagIso) return '';

    let forma = null;

    if (formaIdOrNameOrObj && typeof formaIdOrNameOrObj === 'object') {
      forma = formaIdOrNameOrObj;
    } else if (typeof formaIdOrNameOrObj === 'number') {
      forma = (formasLista || []).find(f => f.id === formaIdOrNameOrObj) || null;
    } else if (typeof formaIdOrNameOrObj === 'string') {
      const nomeAlvo = _norm(formaIdOrNameOrObj);
      forma = (formasLista || []).find(f => _norm(f?.nome) === nomeAlvo) || { nome: formaIdOrNameOrObj };
    }

    if (!forma) return dataPagIso;

    const nome = _norm(forma.nome || '');
    const prazo = Number(forma.prazo_pagamento || 0);
    const d0 = _mkDateLocal(dataPagIso);

    if (nome.includes('informar')) {
      return '';
    }

    if (nome.includes('especie') || nome.includes('cheque') || nome.includes('boleto')) {
      return dataPagIso;
    }

    if (nome.includes('pix')) {
      const dia = _isBusinessDay(d0) ? d0 : _nextBusinessDay(d0);
      return _toISODateLocal(dia);
    }

    if (nome.includes('transferencia') || nome.includes('transferência') || nome.includes('ted')) {
      const dia = _isBusinessDay(d0) ? d0 : _nextBusinessDay(d0);
      return _toISODateLocal(dia);
    }

    if (nome.includes('cartao') && nome.includes('credito') && nome.includes('parcelado')) {
      const parcela = Math.max(1, Number(numeroParcela || 1));
      const baseTeorica = _mkDateLocal(dataPagIso);

      if (parcela === 1) {
        baseTeorica.setDate(baseTeorica.getDate() + 31);
        return _toISODateLocal(_nextBusinessDay(baseTeorica));
      }

      if (parcela === 2) {
        baseTeorica.setDate(baseTeorica.getDate() + 61);
        return _toISODateLocal(_nextBusinessDay(baseTeorica));
      }

      baseTeorica.setDate(baseTeorica.getDate() + (61 + ((parcela - 2) * 30)));
      return _toISODateLocal(_nextBusinessDay(baseTeorica));
    }

    if (
      nome === 'cartao de credito' ||
      (nome.includes('cartao') && nome.includes('credito') && nome.includes('vista'))
    ) {
      const d = _mkDateLocal(dataPagIso);
      d.setDate(d.getDate() + 31);
      return _toISODateLocal(_nextBusinessDay(d));
    }

    if (nome.includes('debito') || nome.includes('débito')) {
      const d = _mkDateLocal(dataPagIso);
      d.setDate(d.getDate() + 1);
      return _toISODateLocal(_nextBusinessDay(d));
    }

    const d = _mkDateLocal(dataPagIso);
    d.setDate(d.getDate() + prazo);
    return _toISODateLocal(_nextBusinessDay(d));
  }
};
};
